<div class="comp-header__queries">
  <adm-text-search placeholder="Søgeord" (search$)="onSearchInput($event)" [searchText]="searchText() ?? ''" />

  <adm-org-typeahead
    [initialId]="organizationId() ?? undefined"
    [resetTrigger]="resetOrgTrigger()"
    (organizationsFetched)="onOrganizationsFetched($event)"
    (clearTypeAhead)="onClearOrganizationSelector()"
    (itemSelected)="onOrganizationSelected($event ?? null)" />

  <adm-location-type-ahead
    [initialId]="locationIdentifier() ?? undefined"
    [organizationId]="organizationId() ?? undefined"
    [resetTrigger]="resetLocationTrigger()"
    (itemSelected)="onLocationSelected($event)" />

  <mat-form-field>
    <mat-label>Vælg Biltype</mat-label>
    <mat-select
      #carTypeSelect="matSelect"
      (selectionChange)="onCarTypeSelected($event.value)"
      [value]="selectedCarType()"
      okCustomDropDownArrowDirective>
      <mat-option [value]="AccessGroupCarType.CompanyCar">Firmabil</mat-option>
      <mat-option [value]="AccessGroupCarType.PrivateCar">Privatbil</mat-option>
    </mat-select>
    @if (selectedCarType()) {
      <button
        matSuffix
        class="clear-input-field-button"
        type="button"
        (click)="onCarTypeSelected(null); $event.stopPropagation()"
        aria-label="Ryd indhold i feltet">
        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
      </button>
    }
    <mat-icon matSuffix />
  </mat-form-field>

  <adm-admin-shared-discount-type-ahead
    [className]="'shared-discount'"
    [initialId]="sharedDiscountIdentifier() ?? undefined"
    [resetTrigger]="resetDiscountTrigger()"
    (itemSelected)="onDiscountSelected($event)" />
  <button class="comp-header__reset-button" (click)="onResetAllFilters()" mat-stroked-button>Nulstil</button>
</div>
